import type { SocialProviderId } from "@app/ui";
import { AUTH_LINK_PATH } from "@/lib/Pathname";

// Capacitor 네이티브(iOS/Android) 앱의 소셜 로그인 진입. 네이티브 셸은 웹을
// server.url 로 원격 로드하는 웹뷰라, 그 웹뷰 안에서 better-auth 의 signIn.social 을
// 그대로 돌리면 OAuth 왕복(cross-site 리다이렉트) 중 단명 state 쿠키가 유실돼
// state_mismatch 가 난다. 게다가 구글은 임베디드 웹뷰 안 OAuth 를 공식 차단한다
// (disallowed_useragent). 그래서 데스크톱과 같은 "진짜 브라우저 로그인 → 딥링크로
// 세션 핸드오프" 패턴을 쓴다:
//
//  1. 여기서 @capacitor/browser 로 시스템 브라우저(SFSafariViewController/Custom Tabs)를
//     열어 랜딩(/auth/link?social=...)을 띄운다 — 그 브라우저는 일반 웹이라 쿠키가 정상.
//  2. 랜딩이 signIn.social 로 OAuth 를 완주(pages/desktop-handoff + queries/desktop-handoff)
//     → 세션이 붙으면 1회용 핸드오프 토큰을 발급해 `<appId>://auth-callback?token=` 딥링크로 리다이렉트.
//  3. components/PlatformBridge 의 appUrlOpen 리스너가 그 딥링크를 받아 브라우저를 닫고
//     verify 로 앱 웹뷰의 자체 세션을 확립한다.
//
// @capacitor/* 는 동적 import 한다 — 호출부(pages/login/Page.tsx)가 웹 entry 청크에
// 정적으로 딸려 있어서, 정적 import 하면 capacitor 코드가 웹 번들로 샌다.

/** 네이티브에서 소셜 로그인을 시작한다. 시스템 브라우저를 랜딩으로 연다. */
export async function openNativeSocialLogin(provider: SocialProviderId): Promise<void> {
  const { App } = await import("@capacitor/app");
  const { Browser } = await import("@capacitor/browser");
  // appId(=딥링크 스킴, scripts/channel.mjs 의 deepLinkScheme). prod=com.withtask.app,
  // develop=com.withtask.app.dev — OS 가 이 스킴을 "지금 실행 중인 그 앱"에 라우팅하므로
  // 랜딩이 어느 스킴으로 돌려줄지 알 수 있게 브라우저 URL 에 실어 보낸다(cb).
  const { id: appId } = await App.getInfo();
  const url = `${window.location.origin}${AUTH_LINK_PATH}?social=${encodeURIComponent(provider)}&cb=${encodeURIComponent(appId)}`;
  await Browser.open({ url });
}
